import { useQuery } from '@tanstack/react-query';
import { apiGet, apiPost } from '@/lib/api';
import type { DraftScenario, DraftVariant } from '@/lib/draftText';

export type TextVoiceExample = {
  id: string;
  playerId: string | null;
  statLineId: string | null;
  scenario: DraftScenario;
  variant: DraftVariant | null;
  draftText: string | null;
  sentText: string;
  league: string | null;
  gameDate: string | null;
  createdAt: number;
  createdBy: string | null;
};

export function useTextVoiceExamples(scenario: DraftScenario) {
  return useQuery<{ items: TextVoiceExample[] }>({
    queryKey: ['text-voice-examples', scenario],
    queryFn: () => apiGet<{ items: TextVoiceExample[] }>(`/api/text-training/examples?scenario=${scenario}&limit=5`),
    staleTime: 30_000,
  });
}

export function saveTextVoiceExample(input: {
  playerId: string;
  statLineId: string;
  scenario: DraftScenario;
  variant: DraftVariant;
  draftText: string;
  sentText: string;
  league: string;
  gameDate: string;
}) {
  return apiPost<{ example: TextVoiceExample }>('/api/text-training/examples', input);
}
